import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@thinkalpha/ui-core/utils';
import { useEvent } from 'src/hooks/useEvent';

interface ClearButtonProps {
    onClick: (e: React.MouseEvent) => void;
    className?: string;
}

export const ClearButton = ({ onClick, className }: ClearButtonProps) => {
    const handleClick = useEvent(onClick);

    const handleMouseDown = useEvent((e: React.MouseEvent) => {
        e.preventDefault();
    });

    return (
        <button
            tabIndex={-1}
            type="button"
            className={cn('absolute -right-0.5 bottom-1 flex items-center p-0 text-xs text-gray-400', className)}
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            aria-label="Clear input"
        >
            <FontAwesomeIcon icon={faTimes} />
        </button>
    );
};
